const bigProjects = [
  
  {
    id: 1,
    name: 'Cars Showcase',
    url: 'https://car-showcase-zeta-one.vercel.app/',
    image: 'images/project-00.png'
  },
  {
    id: 2,
    name: 'Article Summary',
    url: 'https://article-summary-pied.vercel.app/',
    image: 'images/project-01-01.png'
  },
  {
    id: 3,
    name: 'Shopping Cart',
    url: 'https://shopping-cart-gold-two.vercel.app/',
    image: 'images/project-02.png'
  },
  {
    id: 4,
    name: 'myReads',
    url: 'https://myreads-books.vercel.app/',
    image: 'images/project-01.png'
  },
  {
    id: 5,
    name: 'Starred Github Repos',
    url: 'https://starred-github-repos-one.vercel.app/',
    image: 'images/project-03.png'
  },
  {
    id: 6,
    name: 'Dips',
    url: 'https://mahmoudsafaya.github.io/Dips/',
    image: 'images/project-04.png'
  },
  {
    id: 7,
    name: 'News Blog',
    url: 'https://mahmoudsafaya.github.io/otaku/',
    image: 'images/project-05.png'
  },
  {
    id: 8,
    name: 'Restaurant',
    url: 'https://mahmoudsafaya.github.io/Crazy_Resturant/',
    image: 'images/project-06.png'
  },
  {
    id: 9,
    name: 'Save A Link',
    url: 'https://save-link-bice.vercel.app/',
    image: 'images/project-07.png'
  },
  {
    id: 10,
    name: 'Weather',
    url: 'https://mahmoudsafaya.github.io/weather/',
    image: 'images/project-08.png'
  },
  {
    id: 11,
    name: 'Red Store',
    url: 'https://mahmoudsafaya.github.io/redStore/',
    image: 'images/project-09.png'
  },
  
]


export { bigProjects }